<div class="modal-header">
  <h5 class="modal-title">{{ type }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <ng-container *ngIf="documentUrl; else noDocument">
    <!-- Display PDF viewer for PDF files -->
    <ng-container *ngIf="isPdf; else imagePreview">
      <div class="pdf-container">
        <iframe [src]="safeUrl" width="100%" height="500px" frameborder="0"></iframe>
      </div>
      <!-- <div class="mt-2">
        <p>Viewing PDF: {{ getFileName(documentUrl) }}</p>
      </div> -->
    </ng-container>
    
    <!-- Display image viewer for image files -->
    <ng-template #imagePreview>
      <div class="image-container text-center">
        <img [src]="documentUrl" alt="Document Image" class="img-fluid" />
      </div>
      <!-- <div class="mt-2">
        <p>Viewing Image: {{ getFileName(documentUrl) }}</p>
      </div> -->
    </ng-template>
  </ng-container>
  
  <!-- Display placeholder if no document -->
  <ng-template #noDocument>
    <div class="no-document text-center p-5">
      <i class="bx bx-file text-muted" style="font-size: 64px;"></i>
      <p class="mt-3">No document available.</p>
    </div>
  </ng-template>
</div>
<!-- <div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">Close</button>
  <a *ngIf="documentUrl" [href]="documentUrl" target="_blank" class="btn btn-primary">
    <i class="bx bx-download me-1"></i> Download
  </a>
</div> -->